/* eslint-disable @typescript-eslint/no-explicit-any */
import { EwaThunk } from "../types";
import * as requests from "../../requests/modules/requestCreators";
import * as actions from "./actions";
import * as selectors from "./selectors";
import { ModuleId } from "../../globalTypes";

export const fetchAllModulesMetadata =
  (): EwaThunk => async (dispatch, getState) => {
    const state = getState();

    const isFetching = selectors.getIsMetadataFetching(state);
    if (isFetching) return;

    dispatch(actions.requestFetchAllModulesMetadata());

    try {
      const response = await requests.fetchAllModulesMetadata();
      const allModulesMetadata = response.data;

      dispatch(actions.successFetchAllModulesMetadata(allModulesMetadata));
    } catch (e: any) {
      if (!e.response) console.error(e);
      dispatch(actions.errorFetchAllModulesMetadata(e.response)); // TODO: nějak to rozparsovat
    }
  };

export const fetchMetadataForModule =
  (moduleId: ModuleId): EwaThunk =>
  async (dispatch, getState) => {
    const state = getState();

    const isFetching = selectors.getIsMetadataFetchingForModuleId(
      state,
      moduleId
    );
    if (isFetching) return;

    dispatch(actions.requestFetchModuleMetadata(moduleId));

    try {
      const response = await requests.fetchModuleMetadata(moduleId);
      const moduleMetadata = response.data;

      dispatch(actions.successFetchModuleMetadata(moduleMetadata));
    } catch (e: any) {
      if (!e.response) console.error(e);
      dispatch(actions.errorFetchModuleMetadata(moduleId, e.response)); // TODO: nějak to rozparsovat
    }
  };
